import { graphql } from "~/gql";

export const UPDATE_UPLIFT = graphql(/* GraphQL */ `
  mutation updateUplift($id: Float!, $data: UpliftUpdateInput!) {
    updateUplift(id: $id, data: $data) {
      ...UpliftParts
    }
  }
`);

export const UPDATE_UPLIFTS = graphql(/* GraphQL */ `
  mutation updateUplifts($data: [UpdateManyUpliftsInput!]!) {
    updateUplifts(data: $data) {
      ...UpliftParts
    }
  }
`);
